import React from "react";
import { Icon, Wrapper } from "./styles";

interface IconWrapperProps {
  children: React.ReactNode;
}

const IconWrapper = ({ children }: IconWrapperProps) => {
  return (
    <Wrapper>
      <Icon>{children}</Icon>
    </Wrapper>
  );
};

export default IconWrapper;
